export default "__VITE_ASSET__BS27bOQu__ 584w";